<template>
  <div class="col-sm-12">
    <div class="card hovercard text-center">
      <div class="user-image-wrapper">
        <div class="user-image">
          <div class="avatar">
            <div class="initials-avatar" :style="{ backgroundColor: avatar.color, color: avatar.textColor }">
              {{ avatar.initials }}
            </div>
          </div>
        </div>
      </div>

      <div class="info">
        <div class="row" data-intro="This is your details" id="info-bar-tour">
          <div class="col-sm-12 col-lg-12 order-sm-0 order-xl-1">
            <div class="user-designation">
              <div class="title d-flex align-items-center justify-content-center">
                <span class="text-dark fw-bold h4 mb-0">{{ userProfile.fullName }}</span>
              </div>
              <div class="desc mt-2 d-flex align-items-center justify-content-center">
                <span class="text-muted fw-semibold">{{ userProfile.designation }}</span>
              </div>
              <div class="desc mt-2 d-flex align-items-center justify-content-center">
                <span v-if="(userProfile.designation === 'DISTRIBUTOR' || userProfile.designation === 'DISTRIBUTOR BACK OFFICE') && userProfile.distributorVatCode" 
                      class="badge rounded-pill bg-light text-primary border border-primary ms-2" 
                      style="font-size: 0.75rem; font-weight: 500; padding: 0.4em 0.8em;">
                  <i class="fa fa-id-card-o me-1"></i>VAT: {{ userProfile.distributorVatCode }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <hr>

        <!-- Show Data in Text Boxes (Readonly) -->
        <div class="row">
          <div class="col-sm-6 col-lg-6 form-group">
            <p :for="key" class="col-form-label text-start">First Name:</p>
            <input type="text" class="form-control" :value="userProfile.firstName || 'N/A'" readonly />
          </div>

          <div class="col-sm-6 col-lg-6 form-group">
            <p :for="key" class="col-form-label text-start">Last Name:</p>
            <input type="text" class="form-control" :value="userProfile.lastName || 'N/A'" readonly />
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6 col-lg-6 form-group">
            <p :for="key" class="col-form-label text-start">Designation:</p>
            <input type="text" class="form-control" :value="userProfile.designation || 'N/A'" readonly />
          </div>

          <div class="col-sm-6 col-lg-6 form-group">
            <p :for="key" class="col-form-label text-start">Mobile:</p>
            <input type="text" class="form-control" :value="userProfile.mobile || 'N/A'" readonly />
          </div>
        </div>

        <div v-if="userProfile.designation === 'DISTRIBUTOR'" class="row">
          <div class="col-sm-6 col-lg-6 form-group">
            <p :for="key" class="col-form-label text-start">Address:</p>
            <input type="text" class="form-control" :value="userProfile.address || 'N/A'" readonly />
          </div>

          <div class="col-sm-6 col-lg-6 form-group">
            <p :for="key" class="col-form-label text-start">City:</p>
            <input type="text" class="form-control" :value="userProfile.city || 'N/A'" readonly />
          </div>
        </div>

        <div v-if="userProfile.designation === 'DISTRIBUTOR'" class="row">
          <div class="col-sm-6 col-lg-6 form-group">
            <p :for="key" class="col-form-label text-start">District:</p>
            <input type="text" class="form-control" :value="userProfile.district || 'N/A'" readonly />
          </div>

          <div class="col-sm-6 col-lg-6 form-group">
            <p :for="key" class="col-form-label text-start">Province:</p>
            <input type="text" class="form-control" :value="userProfile.province || 'N/A'" readonly />
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6 col-lg-6 form-group">
            <p :for="key" class="col-form-label text-start">Email:</p>
            <input type="text" class="form-control" :value="userProfile.email || 'N/A'" readonly />
          </div>

          <div class="col-sm-6 col-lg-6 form-group">
            <p :for="key" class="col-form-label text-start">Company:</p>
            <input type="text" class="form-control" :value="userProfile.company || 'N/A'" readonly />
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6 col-lg-6 form-group">
            <p :for="key" class="col-form-label text-start">Reporting Person:</p>
            <input type="text" class="form-control" :value="userProfile.reportingL1FirstName+' '+userProfile.reportingL1LastName || 'N/A'" readonly />
          </div>

          <div class="col-sm-6 col-lg-6 form-group">
            <p :for="key" class="col-form-label text-start">Reporting Person's Contact No:</p>
            <input type="text" class="form-control" :value="userProfile.reportingL1Contact || 'N/A'" readonly />
          </div>
        </div>

<!--        <div class="row">-->
<!--          <div class="col-sm-6 col-lg-6 form-group">-->
<!--            <p :for="key" class="col-form-label text-start">{{ userProfile.reportingL2Label}}'s Name:</p>-->
<!--            <input type="text" class="form-control" :value="userProfile.reportingL2FirstName+' '+userProfile.reportingL2LastName || 'N/A'" readonly />-->
<!--          </div>-->

<!--          <div class="col-sm-6 col-lg-6 form-group">-->
<!--            <p :for="key" class="col-form-label text-start">{{ userProfile.reportingL2Label}}'s Contact No:</p>-->
<!--            <input type="text" class="form-control" :value="userProfile.reportingL1Contact || 'N/A'" readonly />-->
<!--          </div>-->
<!--        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userProfile: {
        firstName: "",
        lastName: "",
        fullName: "",
        designation: "",
        mobile: "",
        email: "",
        birthday: "",
        company: "",
        address: "",
        city: "",
        district: "",
        province: "",
        reportingL1Label: "",
        reportingL1FirstName: "",
        reportingL1LastName: "",
        reportingL1Contact: "",
        reportingL2Label: "",
        reportingL2FirstName: "",
        reportingL2LastName: "",
        reportingL2Contact: "",
        distributorVatCode: "",
      },

      avatar: {
        avatarColor: "",
        initials: "",
        textColor: ""
      }
    };
  },
  mounted() {
    // Fetch data from localStorage
    this.userProfile.firstName = localStorage.getItem("first_name");
    this.userProfile.lastName = localStorage.getItem("last_name");
    this.userProfile.fullName = localStorage.getItem("full_name");
    this.userProfile.designation = localStorage.getItem("user_label");
    this.userProfile.mobile = localStorage.getItem("mobile");
    this.userProfile.email = localStorage.getItem("email");
    this.userProfile.birthday = localStorage.getItem("birthday");
    this.userProfile.company = localStorage.getItem("company_name");
    this.userProfile.address = localStorage.getItem("address");
    this.userProfile.city = localStorage.getItem("city");
    this.userProfile.district = localStorage.getItem("district");
    this.userProfile.province = localStorage.getItem("province");
    this.userProfile.reportingL1Label = localStorage.getItem("reportingL1Label");
    this.userProfile.reportingL1FirstName = localStorage.getItem("reportingL1FirstName");
    this.userProfile.reportingL1LastName = localStorage.getItem("reportingL1LastName");
    this.userProfile.reportingL1Contact = localStorage.getItem("reportingL1Contact");
    this.userProfile.reportingL2Label = localStorage.getItem("reportingL2Label");
    this.userProfile.reportingL2FirstName = localStorage.getItem("reportingL2FirstName");
    this.userProfile.reportingL2LastName = localStorage.getItem("reportingL2LastName");
    this.userProfile.reportingL2Contact = localStorage.getItem("reportingL2Contact");
    this.userProfile.distributorVatCode = localStorage.getItem("distributor_vat_code");
    this.avatar.color = localStorage.getItem("avatarColor");
    this.avatar.initials = this.generateInitials(this.userProfile.firstName, this.userProfile.lastName);
    this.avatar.textColor = localStorage.getItem("textColor");
  },
  methods: {
    generateInitials(firstName, lastName) {
      const firstInitial = firstName ? firstName.charAt(0).toUpperCase() : "";
      const lastInitial = lastName ? lastName.charAt(0).toUpperCase() : "";
      return `${firstInitial}${lastInitial}`;
    },
    formatLabel(key) {
      // Capitalize the key and replace underscores with spaces
      return key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase());
    }
  }
};
</script>

<style scoped>
.user-image-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 120px;
}

.user-image {
  position: relative;
  z-index: 2;
}

.initials-avatar {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  font-size: 30px;
  text-transform: uppercase;
}

.form-group {
  margin-bottom: 15px;
}

.form-control {
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  font-size: 16px;
  color: #333;
}

.text-start {
  text-align: left;
  font-weight: bold;
}
</style>
